<script>
export default {
  name: "ReferentForm",
  props: {
    referent: Object,
    persist: Function
  },
  data() {
    return {
      errors: [],
    }
  },
  methods: {
    checkReferentForm(event) {
      this.errors = []
      event.target.classList.add('was-validated')

      if (!this.referent.lastName) {
        this.errors.push('Nom requis.');
      }
      if (!this.referent.firstName) {
        this.errors.push('Prénom requis.');
      }
      if (!this.referent.email) {
        this.errors.push('Email requis.');
      }

      if (this.errors.length === 0) {
        this.persist()
      }

    },
  }
}
</script>

<template>
  <div>
    <form action="#" @submit.prevent="checkReferentForm($event)" method="post">
      <p class="alert alert-danger" v-if="errors.length">
        <b>Merci de corriger les erreurs suivantes:</b>
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </p>
      <div class="row">
        <div class="col lg">
          <div class="mb-3">
            <label for="name" class="form-label">Nom*</label>
            <input type="text" class="form-control" id="name" placeholder="Nom" v-model="referent.lastName" required>
            <div class="invalid-feedback">
              Ce champ ne peut être vide.
            </div>
          </div>
          <div class="mb-3">
            <label for="firstname" class="form-label">Prénom*</label>
            <input type="text" class="form-control" id="firstname" placeholder="Prénom" v-model="referent.firstName"
                   required>
            <div class="invalid-feedback">
              Ce champ ne peut être vide.
            </div>
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">Email*</label>
            <input type="email" class="form-control" id="email" placeholder="John@doe.com" v-model="referent.email"
                   required
                   pattern="[\w\-\.]+@([\w\-]+\.)+[\w\-]{2,4}">
            <div class="invalid-feedback">
              Merci de saisir un email valide.
            </div>
          </div>
        </div>
        <div>
          <button type="submit" class="btn btn-primary">Valider</button>
        </div>
      </div>
    </form>
  </div>
</template>

<style scoped>

</style>